var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showType == 'form-builder')?_c('b-col',{staticClass:"col column-container",class:_vm.selectedElementControlId == _vm.id ? 'column-container-selected' : '',style:(_vm.properties.style),attrs:{"cols":_vm.properties.cols || _vm.cols},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.setSelected.apply(null, arguments)}}},[_c('div',{},[_vm._t("default")],2)]):(_vm.showType == 'form-submitter' || _vm.showType == 'e-form')?_c('b-col',{staticClass:"mt-2 col",class:_vm.properties.cols || _vm.cols ? '' : 'custom-col',style:(_vm.superComputeFormSubmitterValue({
      elementId: this.id,
      property: 'style',
      value: _vm.properties.style,
      defaultValue: '',
      form: this.form,
      componentPage: null
    })),attrs:{"cols":12,"md":_vm.properties.cols || _vm.cols}},[_c('div',{},[_vm._t("default")],2)]):(_vm.showType == 'form-viewer')?_c('b-col',{staticClass:"column-container-viewer col mt-2",style:(_vm.superComputeFormSubmitterValue({
      elementId: this.id,
      property: 'style',
      value: _vm.properties.style,
      defaultValue: '',
      form: this.form,
      componentPage: null
    })),attrs:{"cols":12,"md":_vm.properties.cols || _vm.cols}},[_c('div',{},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }